import { render, staticRenderFns } from "./UniversityUSP.vue?vue&type=template&id=1a8fd869&"
import script from "./UniversityUSP.vue?vue&type=script&lang=js&"
export * from "./UniversityUSP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports